define('SearchSpring.SiteSearch.View', [
    'SearchSpring.ItemSearcher.View',
    'SC.Configuration',
    'SiteSearch.View'
], function SearchSpringSiteSearchView(
    ItemsSearcherView,
    Configuration,
    SiteSearchView
) {
    SiteSearchView.prototype.initialize = function initialize(options) {
        this.itemsSearcherComponent = new ItemsSearcherView({
            application: options.application,
            minLength: Configuration.get('typeahead.minLength', 3),
            maxLength: Configuration.get('searchPrefs.maxLength', 0),
            limit: Configuration.get('typeahead.maxResults', 10),
            sort: Configuration.get('typeahead.sort', 'relevance:desc'),
            highlight: Configuration.get('typeahead.highlight', true)
        });

        this.itemsSearcherComponent.on('itemSelected', this.onItemSelected, this);
        this.itemsSearcherComponent.on('keyUp', this.showReset, this);
        this.itemsSearcherComponent.on('keyDown', this.cleanSearchOnEnter, this);

        this.application = this.options.application;
        // Listening the magnifying glass interactions
        this.application.getLayout().on('toggleItemSearcher', this.toggleItemSearcher, this);
        this.application.getLayout().on('hideItemSearcher', this.hideItemSearcher, this);
    };
    return SiteSearchView;
});
